import { Injectable } from "@angular/core";

@Injectable()
export class TokenService {
  constructor() {}

  getAccessToken() {
    const token = localStorage.getItem("_accessT");
    if (!token || token === "undefined") {
      return null;
    }

    try {
      return JSON.parse(token);
    } catch (e) {
      console.error("Failed to parse access token:", e);
      return null;
    }
  }

  saveAccessToken(Accesstoken) {
    localStorage.setItem("_accessT", JSON.stringify(Accesstoken));
  }

  saveClientID(clientID: string) {
    localStorage.setItem("_cid", JSON.stringify({ clientID: clientID }));
  }

  saveUserAuthToken(userXauth) {
    localStorage.setItem("_usrX_A", JSON.stringify(userXauth));
  }

  deleteAccessToken() {
    localStorage.removeItem("_accssT");
  }

  saveUserToken(value) {
    localStorage.setItem("_utk", JSON.stringify(value));
  }

  getUserAuthToken() {
    let uAth = localStorage.getItem("_usrX_A");
    uAth = JSON.parse(uAth);
    return uAth;
  }

  savePersonalDetails(details) {
    localStorage.setItem("_usr_p_", JSON.stringify(details)); //save user permission
  }

  getPersonalDetails() {
    let details = localStorage.getItem("_usr_p_"); //get user permission
    details = JSON.parse(details);
    return details;
  }

  saveProfileDetails(details) {
    localStorage.setItem("_usr_d", JSON.stringify(details));
  }

  getProfileDetials() {
    let details = localStorage.getItem("_usr_d");
    details = JSON.parse(details);
    return details;
  }

  getUserToken() {
    let utok = localStorage.getItem("_utk");
    utok = JSON.parse(utok);
    return utok;
  }

  getclientID() {
    let cid = localStorage.getItem("_cid");
    cid = JSON.parse(cid);
    return cid;
  }

  saveUserCred(value: any) {
    localStorage.setItem("_usrcred", JSON.stringify(value));
  }

  getUserCred() {
    let ucred = localStorage.getItem("_usrcred");
    ucred = JSON.parse(ucred);
    return ucred;
  }

  //  encodeUserCredentials(clientDetails:any){
  //     let encoded = btoa(clientDetails);
  //     return encoded;
  //   }

  clearStorage() {
    localStorage.removeItem("_usrcred");
    localStorage.removeItem("_utk");
    localStorage.removeItem("_accessT");
    localStorage.removeItem("_cid");
    localStorage.removeItem("_usrX_A");
    localStorage.removeItem("_usr_d");
    localStorage.removeItem("_usr_p_");
    return true;
  }
}
